module.exports = __webpack_public_path__ + "img/energy.a74576ab.jpg";